<template>
  <div class="screen screen__forgot_password screen__background-card">
    <div class="page--container">
      <div class="page--section">
        <el-card class="card card__login">
          <div v-show="!successEmail">
            <header class="card__header">
            <h1 class="h2 card__title">{{$t('pageTitleForgotPassword')}}</h1>
            <p class="card__paragraph">{{$t('pageDescriptionForgotPassword')}}</p>
            </header>
            <password-reset-form
              v-on:success="onSuccess">
            </password-reset-form>
          </div>
          <div v-show="successEmail">
            <header class="card__header">
              <h1 class="h2 card__title">{{$t('authenticationSuccess')}}</h1>
            </header>
            <p class="card__paragraph">
              {{$t('authenticationResetPasswordSuccess')}}
            </p>
            <p class="card__paragraph card__paragraph-emphasized">
              <b>{{successEmail}}</b>
            </p>
            <p class="card__paragraph">
              {{$t('authenticationResetPasswordExpiration')}}
            </p>
            <div class="card__footer">
              <p class="card__footer_footnote">
                <span>{{$t('authenticationResetPasswordRetry')}}</span>
                <a class="card__footer_link" v-on:click.capture="successEmail = null">
                  {{$t('authenticationResetPasswordEdit')}}
                </a>
              </p>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import PasswordResetForm from '@/components/PasswordResetForm.vue';

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        successEmail: null
      }
    },
    methods: {
      onSuccess(email) {
        this.successEmail = email
      },
    },
    components: {
      PasswordResetForm
    }
  }
</script>

<style lang="scss" scoped>
  .card__header {
    position: relative;
  }
  .card__paragraph {
    font-size: 14px;
    margin: 0 0 10px;
  }
  .card__paragraph-emphasized {
    font-weight: bold;
    font-size: 20px;
  }
</style>
